import React from 'react';
import { Link } from 'react-router-dom';
export function Careers() {
  return <div className="max-w-4xl mx-auto px-6 pt-32 pb-24" data-id="element-3234">
      <div className="mb-16" data-id="element-3235">
        <h1 className="text-4xl font-bold text-white mb-4 font-title" data-id="element-3236">
          Join Giga
        </h1>
        <p className="text-neutral-400 font-body text-lg max-w-2xl" data-id="element-3237">
          We're building an AI assistant platform that connects to every tool
          your team uses. Help us build the future of work.
        </p>
      </div>

      <div className="space-y-12" data-id="element-3238">
        {/* Principal Engineer */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-3239">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-3240">
            <div data-id="element-3241">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-3242">
                Principal Engineer
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-3243">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-3244">
                  Engineering
                </span>
                <span data-id="element-3245">•</span>
                <span data-id="element-3246">Remote</span>
                <span data-id="element-3247">•</span>
                <span data-id="element-3248">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-3249">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-3250">
            <p data-id="element-3251">
              We're looking for a hands-on, senior IC to lead backend
              architecture and systems engineering at Giga. Our product is built
              on Linux VMs (not containers), and uses a custom coding harness
              that interacts directly with operating system primitives.
            </p>

            <div data-id="element-3252">
              <h3 className="text-white font-semibold mb-3" data-id="element-3253">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3254">
                <li data-id="element-3255">
                  Architect and maintain our core backend infrastructure built
                  primarily in Ruby.
                </li>
                <li data-id="element-3256">
                  Manage and optimize our Linux VM fleet and sysadmin
                  operations.
                </li>
                <li data-id="element-3257">
                  Build and secure the coding harness that allows our AI agents
                  to execute code safely.
                </li>
                <li data-id="element-3258">
                  Navigate and simplify non-straightforward architectural
                  challenges.
                </li>
              </ul>
            </div>

            <div data-id="element-3259">
              <h3 className="text-white font-semibold mb-3" data-id="element-3260">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3261">
                <li data-id="element-3262">
                  Deep expertise in Ruby and backend systems architecture.
                </li>
                <li data-id="element-3263">
                  Strong Linux sysadmin skills and experience managing VM-based
                  infrastructure.
                </li>
                <li data-id="element-3264">
                  Experience with systems programming and OS-level primitives.
                </li>
                <li data-id="element-3265">
                  Comfortable working in complex, non-standard architectures.
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Head of Product */}
        <div className="bg-neutral-900/40 border border-neutral-800 rounded-2xl p-5 md:p-8" data-id="element-3266">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-6 mb-6" data-id="element-3267">
            <div data-id="element-3268">
              <h2 className="text-2xl font-bold text-white mb-2" data-id="element-3269">
                Head of Product
              </h2>
              <div className="flex items-center gap-3 text-sm text-neutral-400" data-id="element-3270">
                <span className="px-2.5 py-1 rounded-md bg-neutral-800/50 border border-neutral-700/50" data-id="element-3271">
                  Product
                </span>
                <span data-id="element-3272">•</span>
                <span data-id="element-3273">Remote</span>
                <span data-id="element-3274">•</span>
                <span data-id="element-3275">Full-time</span>
              </div>
            </div>
            <Link to="/contact" className="px-6 py-2.5 bg-white text-[#333333] font-medium rounded-lg hover:bg-neutral-200 transition-colors text-center shrink-0" data-id="element-3276">
              Apply Now
            </Link>
          </div>

          <div className="space-y-6 text-neutral-300 font-body leading-relaxed" data-id="element-3277">
            <p data-id="element-3278">
              We're looking for a product leader to help us build and maintain a
              software factory where we go from idea to production in less than
              24 hours. You'll shape the direction of our AI assistant platform
              for teams.
            </p>

            <div data-id="element-3279">
              <h3 className="text-white font-semibold mb-3" data-id="element-3280">What you'll do:</h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3281">
                <li data-id="element-3282">
                  Lead product strategy and execution for the Giga platform.
                </li>
                <li data-id="element-3283">
                  Drive our rapid iteration cycle (idea to production in
                  &lt;24h).
                </li>
                <li data-id="element-3284">
                  Work closely with engineering to define and prioritize
                  features.
                </li>
                <li data-id="element-3285">
                  Get your hands dirty — this is a builder role, not just
                  high-level strategy.
                </li>
              </ul>
            </div>

            <div data-id="element-3286">
              <h3 className="text-white font-semibold mb-3" data-id="element-3287">
                What we're looking for:
              </h3>
              <ul className="list-disc pl-5 space-y-2" data-id="element-3288">
                <li data-id="element-3289">
                  You are already AI-native / AI-pilled and deeply understand
                  the current LLM landscape.
                </li>
                <li data-id="element-3290">
                  Proven experience shipping complex B2B SaaS products rapidly.
                </li>
                <li data-id="element-3291">
                  Willingness to be hands-on in a fast-paced startup
                  environment.
                </li>
                <li data-id="element-3292">Strong product intuition and user empathy.</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>;
}